import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";

const summary = (r) => `${r.filings_advanced} filing update(s), ${r.renewal_reminders} renewal reminder(s), ${r.past_due_reminders} past-due reminder(s), ${r.auto_cancelled} auto-cancellation(s)`;

export const AutomationBar = () => {
  const [last, setLast] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/automation/log").then((r) => setLast(r.data[0] || null)).catch(() => {});
  }, []);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/automation/run");
      setLast({ ...data, at: new Date().toISOString() });
      toast.success(`Automation ran: ${summary(data)}`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-4 flex flex-col gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm md:flex-row md:items-center md:justify-between" data-testid="automation-bar">
      <p className="flex items-center gap-2 text-emerald-900"><Zap className="h-4 w-4" /> Autopilot on: instant pricing, hourly SR22 updates, renewal & past-due reminders, auto-cancel after 30 days unpaid.
        {last && <span className="text-emerald-700" data-testid="automation-last-run"> Last run {new Date(last.at).toLocaleString()}: {summary(last)}.</span>}</p>
      <Button size="sm" variant="outline" onClick={run} disabled={busy} data-testid="automation-run-btn">{busy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}Run now</Button>
    </div>
  );
};
